import PropTypes from 'prop-types'
import React from 'react'

import RequireUserOnGuestList from 'containers/RequireUserOnGuestList'

const NoInvitationRSVPView = (props) => {
  const { requestedRsvp, guestName } = props
  const isAccept = requestedRsvp === 'accepted'
  const canMakeIt = isAccept ? "know you're going!" : "know you can't make it!"
  const loginMessage = `Add yourself to the guest list to let {host_name} ${canMakeIt}`
  const subscribeMessage = `{user_first_name}, add yourself to the guest list to let {host_name} ${canMakeIt}`

  let rsvpText = 'Can you make it?'
  if (guestName) {
    rsvpText = `Can you make it, ${guestName}?`
  }

  return (
    <div>
      {requestedRsvp !== '' ? (
        <RequireUserOnGuestList
          loginMessage={loginMessage}
          subscribeMessage={subscribeMessage}
          requestedRsvp={requestedRsvp}
          transparent
        />
      ) : (
        rsvpText
      )}
    </div>
  )
}

NoInvitationRSVPView.propTypes = {
  guestName: PropTypes.string,
  requestedRsvp: PropTypes.string.isRequired
}

export default NoInvitationRSVPView



// WEBPACK FOOTER //
// ./src/components/rsvp_modal/NoInvitationRSVPView.jsx